import envVar from '../config/envVars';
import httpPut from './httpClient/httpPut';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import {
  PromoteStudentsPayload,
  ProvisionalPromotionPayload
} from '../types/studentPromotionType';

const promoteStudents = async (payload: PromoteStudentsPayload) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/students/promote`;
  return httpPut(url, payload, {
    headers: { 'Content-Type': 'application/json' }
  });
};

const getFixedConcessionsMaster = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${school}/optional-concessions-master`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_PAYMENTS_API_TOKEN}`
      }
    }
  );
};

const provisionalPromotion = async (payload: ProvisionalPromotionPayload) => {
  return httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/provisional-promotion`,
    payload
  );
};

const studentPromotionApis = {
  promoteStudents,
  getFixedConcessionsMaster,
  provisionalPromotion
};

export default studentPromotionApis;
